import { orpc } from "@/utils/orpc.client";
import type { FeaturePageFamily } from "@garimpa/lib/featurePage";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

export function getFeaturePageQueryOptions(input: {
  family: FeaturePageFamily;
  slug: string;
  locale: ViewerLocale;
}) {
  return orpc.featurePages.getRenderModel.queryOptions({ input });
}
